export function roundOff(num: string) {
  const firstNonZeroIndex = num.search(/[1-9]/);

  return Number(num).toFixed(firstNonZeroIndex + 1);
}
